import { Avatar, Button, Flex, Tooltip, Typography } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';

interface HeaderActionsProps {
  userInfo: { name: string; avatar: string } | null;
  isMobile: boolean;
  onLogout: () => void;
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({
  userInfo,
  isMobile,
  onLogout,
}) => (
  <Flex align="center" className="header-actions">
    <Tooltip title={userInfo?.name || 'Admin'}>
      <Avatar
        size={isMobile ? 24 : 28}
        src={userInfo?.avatar}
        icon={!userInfo?.avatar && <UserOutlined />}
        className="avatar"
      />
    </Tooltip>
    <Button
      type="text"
      icon={<LogoutOutlined />}
      onClick={onLogout}
      className="logout-button"
    >
      {!isMobile && 'Logout'}
    </Button>
  </Flex>
);
